document.addEventListener( 'DOMContentLoaded', function () {
	const list = document.querySelector( '[data-media-albums-list]' );

	if ( ! list ) {
		return;
	}

	const inner = list.querySelector( '[data-media-albums-list-inner]' );
	const loader = list.querySelector( '[data-media-albums-list-loader]' );
	const sentinel = list.querySelector( '[data-media-albums-list-sentinel]' );

	const config = {
		ajaxUrl: list.dataset.ajaxUrl,
		nonce: list.dataset.nonce,
	};

	let offset = parseInt( list.dataset.offset, 10 ) || 0;
	let hasMore = list.dataset.hasMore === '1';
	let isLoading = false;

	if ( ! hasMore || ! sentinel || ! config.ajaxUrl || ! inner ) {
		return;
	}

	async function loadMore() {
		if ( isLoading || ! hasMore ) {
			return;
		}

		isLoading = true;
		list.classList.add( 'is-loading' );

		try {
			const body = new FormData();

			body.append( 'action', 'fd_get_media_albums_list' );
			body.append( 'nonce', config.nonce );
			body.append( 'offset', String( offset ) );

			const response = await fetch( config.ajaxUrl, {
				method: 'POST',
				credentials: 'same-origin',
				body,
			} );

			const data = await response.json();

			if ( ! data.success ) {
				return;
			}

			if ( data.data.html ) {
				const temp = document.createElement( 'div' );
				temp.innerHTML = data.data.html;

				temp.querySelectorAll( '.media-albums__list-item' ).forEach( function ( item ) {
					inner.appendChild( item );
				} );
			}

			hasMore = Boolean( data.data.has_more );
			offset = data.data.next_offset ?? offset;
			list.dataset.hasMore = hasMore ? '1' : '0';
			list.dataset.offset = String( offset );

			if ( ! hasMore ) {
				loader?.remove();
				sentinel.remove();
				observer.disconnect();
			}
		} catch ( error ) {
			console.error( 'media-albums-list:', error );
		} finally {
			isLoading = false;
			list.classList.remove( 'is-loading' );
		}
	}

	const observer = new IntersectionObserver(
		function ( entries ) {
			if ( entries.some( function ( entry ) {
				return entry.isIntersecting;
			} ) ) {
				loadMore();
			}
		},
		{
			rootMargin: '200px 0px',
		}
	);

	observer.observe( sentinel );
} );
